export const shopify = ({ query, variables }) => {
  const fetch = typeof window !== 'undefined' ? window.fetch : require('node-fetch').default

  return fetch('https://' + process.env.VUE_APP_SHOPIFY_DOMAIN + '/api/2020-10/graphql', {
    method: 'POST',
    headers: {
      'X-Shopify-Storefront-Access-Token': process.env.VUE_APP_SHOPIFY_TOKEN,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query, variables })
  })
    .then(resp => resp.json())
    .then(data => {
      if (data.errors) {
        console.error(data.errors)
        return Promise.reject(new Error('Shopify API Response Errors'))
      }
      return data
    })
    .catch(e => console.error('Shopify API Error:', { error: e, query, variables }))
}

const productItemBody = `
  title
  handle
  vendor
  productType
  updatedAt
  availableForSale
  priceRange {
    minVariantPrice {
      amount
      # currencyCode
    }
  }
  images (first: 2) {
    edges {
      node {
        originalSrc
        altText
      }
    }
  }
  tags
  variants (first:2) {
    edges {
      node {
        # availableForSale
        # use product.priceRange....
        # priceV2 {
          # amount
        # }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  options {
    name
    values
  }
`

const productBody = `
  availableForSale
  title
  handle
  vendor
  productType
  description
  descriptionHtml
  priceRange {
    minVariantPrice {
      amount
      # currencyCode
    }
  }
  images (first:20) {
    edges {
      node {
        altText
        originalSrc
        meta: transformedSrc (maxWidth: 1200)
      }
    }
  }
  options {
    name
    values
  }
  variants (first:12) {
    edges {
      node {
        availableForSale
        id
        title
        sku
        quantityAvailable
        priceV2 {
          amount
        }
        image {
          altText
          originalSrc
        }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  tags
  # collections (first:3) {
    # edges {
      # node {
        # handle
        # title
      # }
    # }
  # }
`

const checkoutBody = `
  id
  completedAt
  webUrl
  subtotalPriceV2 {
    amount
  }
  totalPriceV2 {
    amount
  }
  lineItems (first:250) {
    edges {
      node {
        id
        quantity
        title
        variant {
          availableForSale
          id
          title
          sku
          priceV2 {
            amount
          }
          image {
            altText
            originalSrc
          }
          selectedOptions {
            name
            value
          }
        }
        customAttributes {
          key
          value
        }
      }
    }
  }
  shippingAddress {
    countryCodeV2
  }
`

export const queryProducts = (full = false) => `
  query ($first: Int!, $after: String, $query: String, $sortKey: ProductSortKeys, $reverse: Boolean) {
    products (first: $first, query: $query, after: $after, sortKey: $sortKey, reverse: $reverse) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ${full ? productBody : productItemBody}
        }
      }
    }
  }
`

export const queryProduct = `
  query ($handle: String!) {
    productByHandle (handle: $handle) {
      ${productBody}
    }
  }
`

export const queryCheckout = `
  query ($id: ID!) {
    node (id: $id) {
      ...on Checkout {
        ${checkoutBody}
      }
    }
  }
`
export const mutateCreateCheckout = `
  mutation checkoutCreate($input: CheckoutCreateInput!) {
    checkoutCreate(input: $input) {
      checkout {
        ${checkoutBody}
      }
    }
  }
`

export const mutateCheckoutItems = `
  mutation ($id: ID!, $lineItems: [CheckoutLineItemInput!]!) {
    checkoutLineItemsReplace (checkoutId: $id, lineItems: $lineItems) {
      checkout {
        ${checkoutBody}
      }
    }
  }
`

// export const queryCollection = `
//   query ($handle: String!, $first: Int!, $after: String, $imgMaxW: Int, $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
//     collectionByHandle (handle: $handle) {
//       title
//       handle
//       description
//       products (first:$first, after: $after, sortKey: $sortKey, reverse: $reverse) {
//         pageInfo {
//           hasNextPage
//         },
//         edges {
//           cursor
//           node {
//             ${productItemBody}
//           }
//         }
//       }
//     }
//   }
// `
